import React from 'react';
import ServicePage from '../components/ServicePage';
import heroBillede from '../images/TilbygningHero.jpg';

function Tilbygning() {
  return (
    <ServicePage
      slug="tilbygning"
      path="/tilbygning"
      navn="Tilbygning"
      seo={{
        title: 'Tilbygning – udgravning & fundament | JBC Entreprenøren',
        description: 'Tilbygning og ombygning i Holbæk, Roskilde, Tølløse og på hele Sjælland. Vi hjælper dig med mere plads – fra udgravning til færdig løsning. Gratis tilbud.',
        image: 'https://jbcentreprenoeren.dk/images/og-tilbygning.jpg',
        serviceName: 'Tilbygning og ombygning',
      }}
      hero={{
        titel: 'Tilbygning og ombygning',
        tekst: 'Vi hjælper husejere på hele Sjælland med at realisere drømmen om mere plads og en bedre bolig.',
        cta: 'Få tilbud på tilbygning',
        billede: heroBillede,
        billedeAlt: 'Moderne hus med ny tilbygning',
      }}
      intro={{
        titel: 'Mere plads – gjort ordentligt',
        tekst: [
          'JBC Entreprenøren laver tilbygninger i Holbæk, Roskilde, Tølløse og resten af Sjælland.',
          'Vi sørger for, at alt bliver gjort ordentligt fra første spadestik, så du får en god og pålidelig løsning.',
        ],
      }}
      ydelser={{
        titel: 'Vores tilbygningstjenester',
        punkter: [
          'Udvidelse af eksisterende huse',
          'Nye værelser og stuer',
          'Køkken- og badudvidelser',
          'Carporte og garager',
          'Orangerier og vinterhaver',
        ],
      }}
      fordele={{
        titel: 'Derfor vælger kunder os til tilbygninger',
        punkter: [
          'Lokalt kendskab til byggeregler i Nordvestsjælland',
          'Erfaring med alle typer tilbygninger',
          'Kvalitetsmaterialer og håndværk',
          'Professionel projektledelse',
          'Garanti på arbejdet',
        ],
      }}
      kontaktTekst="Skal du have bygget en tilbygning? Vi hjælper gerne med dit projekt."
    />
  );
}

export default Tilbygning;
